import { normalizeKnownBuiltinAgentControllerId } from "./schemas/daemon/agent-controller-ref.js";
//#region src/agent-controller-brand.ts
const BUILTIN_AGENT_CONTROLLER_DISPLAY_ORDER = [
	"codex",
	"claude-code",
	"grok-build",
	"opencode",
	"antigravity",
	"openclaw",
	"cursor"
];
const BUILTIN_AGENT_CONTROLLER_BRAND_IDS = BUILTIN_AGENT_CONTROLLER_DISPLAY_ORDER;
const BUILTIN_AGENT_CONTROLLER_BRANDS = {
	antigravity: {
		accentHex: "#4f7df3",
		accentRgb: [
			79,
			125,
			243
		],
		controllerId: "antigravity",
		selectionMixPercent: 32
	},
	"claude-code": {
		accentHex: "#d97757",
		accentRgb: [
			217,
			119,
			87
		],
		controllerId: "claude-code",
		selectionMixPercent: 34
	},
	codex: {
		accentHex: "#869fff",
		accentRgb: [
			134,
			159,
			255
		],
		controllerId: "codex",
		selectionMixPercent: 36
	},
	cursor: {
		accentHex: "#000000",
		accentRgb: [
			0,
			0,
			0
		],
		controllerId: "cursor",
		selectionMixPercent: 24
	},
	"grok-build": {
		accentHex: "#1d9bf0",
		accentRgb: [
			29,
			155,
			240
		],
		controllerId: "grok-build",
		selectionMixPercent: 30
	},
	opencode: {
		accentHex: "#000000",
		accentRgb: [
			0,
			0,
			0
		],
		controllerId: "opencode",
		selectionMixPercent: 24
	},
	openclaw: {
		accentHex: "#d43838",
		accentRgb: [
			212,
			56,
			56
		],
		controllerId: "openclaw",
		selectionMixPercent: 32
	}
};
const BUILTIN_AGENT_CONTROLLER_DISPLAY_RANK = new Map(BUILTIN_AGENT_CONTROLLER_DISPLAY_ORDER.map((controllerId, index) => [controllerId, index]));
function compareAgentControllerRefsForDisplay(left, right) {
	const leftControllerId = normalizeKnownBuiltinAgentControllerId(left);
	const rightControllerId = normalizeKnownBuiltinAgentControllerId(right);
	if (leftControllerId === rightControllerId && leftControllerId !== null) return 0;
	const leftRank = leftControllerId ? BUILTIN_AGENT_CONTROLLER_DISPLAY_RANK.get(leftControllerId) : void 0;
	const rightRank = rightControllerId ? BUILTIN_AGENT_CONTROLLER_DISPLAY_RANK.get(rightControllerId) : void 0;
	if (leftRank !== rightRank) return (leftRank ?? Number.POSITIVE_INFINITY) - (rightRank ?? Number.POSITIVE_INFINITY);
	return left.localeCompare(right);
}
function isBuiltinAgentControllerBrandId(value) {
	return value in BUILTIN_AGENT_CONTROLLER_BRANDS;
}
function resolveBuiltinAgentControllerBrand(agentControllerRef) {
	if (!agentControllerRef) return null;
	const controllerId = normalizeKnownBuiltinAgentControllerId(agentControllerRef);
	if (!(controllerId && isBuiltinAgentControllerBrandId(controllerId))) return null;
	return BUILTIN_AGENT_CONTROLLER_BRANDS[controllerId];
}
//#endregion
export { BUILTIN_AGENT_CONTROLLER_BRANDS, BUILTIN_AGENT_CONTROLLER_BRAND_IDS, BUILTIN_AGENT_CONTROLLER_DISPLAY_ORDER, compareAgentControllerRefsForDisplay, isBuiltinAgentControllerBrandId, resolveBuiltinAgentControllerBrand };

//# sourceMappingURL=agent-controller-brand.js.map